export const SLUG_DOMAIN = import.meta.env.VITE_CMS_SLUG_DOMAIN || '.blgg.dev'
